import { render, staticRenderFns } from "./SysStCoding.vue?vue&type=template&id=baa45642&scoped=true"
import script from "./SysStCoding.vue?vue&type=script&lang=js"
export * from "./SysStCoding.vue?vue&type=script&lang=js"
import style0 from "./SysStCoding.vue?vue&type=style&index=0&id=baa45642&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa45642",
  null
  
)

export default component.exports